module.exports = __webpack_public_path__ + "static/media/four-point-dice.e48a7b65.svg";